import { CaseTerminalStep } from "@recobra/schemas/case";
import type { TaskType } from "@recobra/schemas/task-catalog";

import type { TaskTypes } from "../task-data";

/**
 * Task types a person may pick when creating a task on a parent: its scope's active ones not
 * owned by automation, and primary ones only for callers holding `createPrimary`; none on a
 * deleted or archived case. Mirrors the server's creation gate.
 */
export const creatableTaskTypes = (
  scopeTaskTypes: TaskTypes,
  caseStep: string | undefined,
  canCreatePrimary: boolean,
): TaskType[] =>
  CaseTerminalStep.safeParse(caseStep).success
    ? []
    : [...scopeTaskTypes.values()].filter(
        (taskType) =>
          taskType.active && !taskType.automatedOnly && (canCreatePrimary || taskType.secondary),
      );
